import { EditorAnnotation } from './editor-annotations';
import { OptionalContentConfig } from './optional_content_config';
import { PDFPageView } from './pdf_page_view';

export enum ScrollModeType {
  vertical = 0,
  horizontal = 1,
  wrapped = 2,
  page = 3,
}

export enum SpreadModeType {
  UNKNOWN = -1,
  NONE = 0, // Default value.
  ODD = 1,
  EVEN = 2,
}

export type PageViewModeType = 'single' | 'book' | 'multiple' | 'infinite-scroll';

export interface ScrollModeChangedEvent {
  mode: ScrollModeType;
}
export interface IPDFRenderingQueue {
  getHighestPriority(visiblePage: Array<any>, pages: Array<any>, scrolledDown: boolean, preRenderExtra: boolean): any;
  renderView(pageView: any): void; // Added for iOS canvas optimization
}

export interface IPDFViewer {
  maxZoom: number;
  minZoom: number;
  maxCanvasPixels: number; // Added for iOS canvas optimization
  setTextLayerMode(textLayerMode: number): unknown;
  annotationEditorMode: any;
  currentPageLabel: string | undefined;
  currentPageNumber: number;
  enablePrintAutoRotate: boolean;
  currentScale: number;
  currentScaleValue: string | number;
  pagesRotation: 0 | 90 | 180 | 270;
  removePageBorders: boolean;
  renderingQueue: IPDFRenderingQueue;
  scrollMode: ScrollModeType;
  pageViewMode: PageViewModeType;
  spreadMode: 0 | 1 | 2;
  _pages: Array<PDFPageView>;
  addPageToRenderQueue(pageIndex: number): boolean;
  _getVisiblePages(): Array<any>;
  optionalContentConfigPromise: Promise<OptionalContentConfig> | null;
  _scrollPageIntoView({ pageDiv, pageSpot, pageNumber }: { pageDiv: HTMLElement; pageSpot: any; pageNumber: number }): void;
  getSerializedAnnotations(): EditorAnnotation[] | null; // #1783 added by ngx-extended-pdf-viewer
  addEditorAnnotation(serialized: string | EditorAnnotation | Array<EditorAnnotation>): Promise<void>; // #1783 added by ngx-extended-pdf-viewer, array support documented in #3254
  removeEditorAnnotations(filter?: (serialized: EditorAnnotation) => boolean): void; // #1783 added by ngx-extended-pdf-viewer
  getPageView(index: number): PDFPageView;
  destroyBookMode(): void;
  stopRendering(): void;
  refresh(noUpdate?: boolean, updateArgs?: object): void;
  enableFlipByDrag: boolean; // #3140 added by ngx-extended-pdf-viewer
  pageFlip: { setting: { showPageCorners: boolean; enableFlipByDrag: boolean } } | null; // #3140 added by ngx-extended-pdf-viewer
  /** #3140 book mode: the folded corner a page shows when the mouse comes near it */
  showPageCorners: boolean;
  /** #3155 book mode: re-reads the reading direction. Not available in older engines. */
  updateBookReadingDirection?(): void;
}
